import React, {useEffect} from 'react'
import {useState, useCallback} from 'react';
import Card from '../edit-page/Card';
import Button from '../common/Button';
import ProjectStore from '../../store/projectStore'
import ProjectCollaborationCardEditableListSection from './ProjectCollaborationCardEditableListSection';
import {useStaticRendering} from 'mobx-react';

/**
 * Adds specified value to the list and calls the updater.
 *
 * @param {Array<any>} list
 * @param {any} value
 * @param {Function} updater
 */
function addAndUpdate(list, value, updater) {
    let nextList = [...list];
    nextList.push(value);
    updater(nextList);
    ProjectStore.setDirty(true);
    return nextList;
}

/**
 * Removes specified value from the list and calls the updater.
 *
 * @param {Array<any>} list
 * @param {any} value
 * @param {Function} updater
 */
function removeAndUpdate(list, value, updater) {
    let nextList = [...list];
    nextList.splice(nextList.findIndex(x => x.value === value.value), 1);
    updater(nextList);
    ProjectStore.setDirty(true);
    return nextList;
}

export default function ProjectCollaborationCard(props) {
    let possibleParticipants = [];
    let possibleViewers = [];
    if (props.members.length > 0) {
        possibleParticipants = props.members || [];
        possibleViewers = props.members || [];
    }

    const [editable, setEditable] = useState({});
    //const [editable, setEditable] = useState(false);
    const [IsEditable, setIsEditable] = useState(false);
    const [participants, setParticipants] = useState(props.projectMembers.participants);
    const [viewers, setViewers] = useState(props.projectMembers.viewers);

    const handleToggleEditable = (id, value) => {
        if (!value) {
            props.onParticipantsChanged(participants);
            props.onViewersChanged(viewers);
        }
        let newEditable = {
            ...editable,
            [id]: value
        };

        setEditable(newEditable);
    };

    useEffect(() => {
        ProjectStore.setCollaborationDuringEdit(Object.values(editable).some(x => x))
    }, [editable])

    const handleAddClick = (option, list, list2, updater) => {

        let model = list2.find(x => x.value === option.value);

        let exists = list.find(x => x.value === option.value) != undefined; //check if user is on the list

        if (!exists && model) {
            addAndUpdate(list, model, updater);
        }
    };

    const handleRemoveClick = (option, list, list2, updater) => {

        let model = list2.find(x => x.value === option.value);
        if (model) {
            removeAndUpdate(list, model, updater);
        }
    };

    const handleParticipantAddClick = useCallback(participant => {
        handleAddClick(participant, participants, possibleParticipants, setParticipants);
    }, [possibleParticipants, participants]);

    const handleParticipantRemoveClick = useCallback(participant => {
        handleRemoveClick(participant, participants, possibleParticipants, setParticipants);
    }, [possibleParticipants, participants]);

    const handleViewerAddClick = useCallback(viewer => {
        handleAddClick(viewer, viewers, possibleViewers, setViewers);
    }, [possibleViewers, viewers]);

    const handleViewerRemoveClick = useCallback(viewer => {
        handleRemoveClick(viewer, viewers, possibleViewers, setViewers);
    }, [possibleViewers, viewers]);

    function customerClick() {
        handleParticipantAddClick(props.activeUser.user);
    }

    function renderCustomButton() {
        if (true) {
            return (

                <Button size={Button.Size.Small} theme={Button.Theme.BorderOnly} onClick={customerClick}>
                    {__('Include me')}
                </Button>

            );
        }

        return (<React.Fragment></React.Fragment>)
    }

    const canEdit = () => props.canEditParticipants || props.canEditViewers;

    return (
        <Card helpInfo={props.helpInfo} label="Collaboration">
            <div className="row row-no-outer-gutter">
                <div className="column-6 column-xs-12">
                    <ProjectCollaborationCardEditableListSection
                        title={__('Participants')}
                        editable={props.canEditParticipants}
                        value={participants}
                        autocompleteSuggestions={possibleParticipants}
                        boldAutocompleteSuggestions={props.activeUser}
                        onParticipantAddClick={handleParticipantAddClick}
                        onParticipantRemoveClick={handleParticipantRemoveClick}
                        handleToggleEditable={(value) => handleToggleEditable('participants', value)}
                    />
                </div>

                <div className="column-6 column-xs-12">
                    <ProjectCollaborationCardEditableListSection
                        title={__('Viewers')}
                        editable={props.canEditViewers}
                        value={viewers}
                        autocompleteSuggestions={possibleViewers}
                        boldAutocompleteSuggestions={props.activeUser}
                        onParticipantAddClick={handleViewerAddClick}
                        onParticipantRemoveClick={handleViewerRemoveClick}
                        handleToggleEditable={(value) => handleToggleEditable('viewers', value)}
                    />
                </div>
            </div>
        </Card>
    )
}
